export const isTopRetail = (rank?: string) => {
  if (!rank) {
    return false
  }
  return rank === 'Top Retail'
}
